<template>
  <table class="my-5">
    <tr>
      <td colspan="2" class="bolder pb-3" :class="question.answer !== answer.answer ? 'red-text' : ''">
        <mdb-icon v-if="question.answer === answer.answer" far icon="circle" class="correct"/>
        <mdb-icon v-else icon="times" class="incorrect"/>
        {{num+1}}. <span v-html="$linebreak(question.question)"/>
        (정답: {{question.answer}})
        </td>
    </tr>
    <tr>
      <td style="width:20px"><mdb-badge v-if="question.answer === 1" color="primary">정답</mdb-badge></td>
      <td :class="{bolder: answer.answer === 1, 'red-text': question.answer === 1}">
        1) {{question.q1}}
      </td>
    </tr>
    <tr >
      <td style="width:20px"><mdb-badge v-if="question.answer === 2" color="primary">정답</mdb-badge></td>
      <td :class="{bolder: answer.answer === 2, 'red-text': question.answer === 2}">2)
        {{question.q2}}
      </td>
    </tr>
    <tr>
      <td style="width:20px"><mdb-badge v-if="question.answer === 3" color="primary">정답</mdb-badge></td>
      <td :class="{bolder: answer.answer === 3, 'red-text': question.answer === 3}">
        3) {{question.q3}}
      </td>
    </tr>
    <tr>
      <td style="width:20px"><mdb-badge v-if="question.answer === 4" color="primary">정답</mdb-badge></td>
      <td :class="{bolder: answer.answer === 4, 'red-text': question.answer === 4}">
        4) {{question.q4}}
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'QuestionView',
  props: ['num', 'question', 'answer'],
  methods: {
    isCorrect () {
      return this.answer.correct ? 'circle' : 'times'
    }
  }
}
</script>
<style scoped>
td {
  font-size: 16px;
}
.correct {
  font-size: 30px;
  color: green;
}
.incorrect {
  font-size: 30px;
  color: red;
}

</style>
